var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"openInstrument"},[_c('div',{staticClass:"left"},[_c('Left')],1),_c('div',{staticClass:"right"},[_c('keep-alive',[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }